import React from 'react'
import { shape, string } from 'prop-types'
import * as Styled from './ContactPerson.styles'
import { Icon } from 'components/atoms'
import { Display4 } from 'components/atoms/IcoMoon'
// import { requiredEmailPropType } from 'settings/propTypeDefinitions'

const ContactPerson = ({ contactPerson }) => {
  const { title, name, phone, fax, email, website, address } = contactPerson

  return (
    <Styled.ContactPerson>
      <div className='contact-person'>
        {!!title && (
          <p className='contact-person-title'>
            <b>{title}</b>
          </p>
        )}
        <p className='contact-person-name'>{name}</p>
        {address && (
          <p className='contact-person-address'>
            <Styled.ContactIcon>
              <Icon className='icon-f-home' />
            </Styled.ContactIcon>
            <span>
              {address.street}, {address.zip}, {address.city}
            </span>
          </p>
        )}
        {phone && (
          <p className='contact-person-phone'>
            <Styled.ContactIcon>
              <Icon className='icon-f-phone-handset' />
            </Styled.ContactIcon>
            <a href={ `tel:${ phone }` }>{phone}</a>
          </p>
        )}
        {fax && (
          <p className='contact-person-fax'>
            <Styled.ContactIcon>
              <Icon className='icon-f-printer' />
            </Styled.ContactIcon>
            {fax}
          </p>
        )}
        {email && (
          <p className='contact-person-email'>
            <Styled.ContactIcon>
              <Icon className='icon-f-envelope' />
            </Styled.ContactIcon>
            <a
              href={ `mailto:${ email }` }
              target='_blank'
              rel='noopener noreferrer'>
              {email}
            </a>
          </p>
        )}
        {website && (
          <p className='contact-person-website'>
            <Styled.ContactIcon>
              <Display4 />
            </Styled.ContactIcon>
            <a href={ `${ website }` } target='_blank' rel='noopener noreferrer'>
              {website}
            </a>
          </p>
        )}
      </div>
    </Styled.ContactPerson>
  )
}

ContactPerson.propTypes = {
  contactPerson: shape({
    title: string,
    name: string.isRequired,
    phone: string,
    // email: requiredEmailPropType,
    email: string,
  }).isRequired,
}

export default ContactPerson
